// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LAKPED-16.2 — «qué sabemos ya» de la pieza. Mismos valores que el prototipo de Paula,
   acotado a .part-history porque el CSS de CRA es global. */

.part-history {
  max-width: 1200px;
  margin: 0 auto;
  padding: 28px 32px 60px;
}

.part-history h1 {
  font-size: 26px;
  font-weight: 600;
  margin: 0 0 4px;
  color: #1b1b1b;
}

.part-history-sub { color: #666; font-size: 14px; margin: 0 0 20px; }
.part-history-cargando { color: #666; font-size: 14px; }
.part-history-error {
  color: #5a2a00;
  background: #fff0e3;
  border-left: 4px solid #e46a00;
  border-radius: 0 6px 6px 0;
  padding: 9px 12px;
  font-size: 13px;
}

/* Pasos */
.part-history-pasos {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  list-style: none;
  margin: 0 0 20px;
  padding: 0;
}

.part-history-pasos li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #888;
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 20px;
  padding: 5px 14px 5px 6px;
}

.part-history-pasos li.hecho { color: #333; }
.part-history-pasos li.actual { color: #1b1b1b; }

.part-history-paso-num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #e5e5e5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #555;
}

.part-history-pasos li.actual .part-history-paso-num { background: #111; color: #fff; }
.part-history-pasos li.hecho .part-history-paso-num { background: #dff5e8; color: #157347; }

/* Tarjeta de la pieza */
.part-history-pieza {
  background: #fff;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  overflow: hidden;
}

.part-history-cabecera {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: #fafafa;
  border-bottom: 1px solid #eee;
}

.part-history-cabecera strong { font-size: 16px; color: #1b1b1b; }
.part-history-aviso { font-size: 13px; color: #8a6100; }
.part-history-chips { display: flex; flex-wrap: wrap; gap: 6px; }

.part-history-chip {
  display: inline-block;
  background: #f0f0f0;
  color: #333;
  border-radius: 14px;
  padding: 3px 10px;
  font-size: 12px;
}

.part-history-chip.verde { background: #dff5e8; color: #157347; }
.part-history-chip.ambar { background: #fff1cc; color: #8a6100; }

.part-history-cuerpo { padding: 14px 18px; border-bottom: 1px solid #f2f2f2; }
.part-history-cuerpo:last-child { border-bottom: none; }
.part-history-cuerpo h3 { font-size: 14px; font-weight: 600; margin: 0 0 10px; color: #1b1b1b; }

/* Tabla del histórico */
.part-history-tabla { width: 100%; border-collapse: collapse; font-size: 13px; }
.part-history-tabla th {
  text-align: left;
  font-weight: 600;
  font-size: 12px;
  color: #666;
  padding: 6px 8px;
  border-bottom: 1px solid #eee;
}
.part-history-tabla td { padding: 7px 8px; border-bottom: 1px solid #f4f4f4; color: #333; }
.part-history-tabla th.der, .part-history-tabla td.der { text-align: right; }
.part-history-tabla tbody tr:last-child td { border-bottom: none; }

.part-history-tabla button,
.part-history-ofertas button,
.part-history-planos button,
.part-history-similares button {
  border: none;
  background: none;
  padding: 0;
  color: #2563b0;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  text-align: left;
}

.part-history-tabla button:hover,
.part-history-ofertas button:hover,
.part-history-planos button:hover,
.part-history-similares button:hover { text-decoration: underline; }

.part-history-pie { font-size: 12.5px; color: #777; margin: 8px 0 0; }
.part-history-vacio { font-size: 14px; color: #333; margin: 0 0 12px; }

.part-history-ofertas,
.part-history-planos,
.part-history-similares { list-style: none; margin: 0; padding: 0; }

.part-history-ofertas li,
.part-history-planos li,
.part-history-similares li {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 10px;
  padding: 6px 0;
  border-bottom: 1px solid #f4f4f4;
  font-size: 13px;
  color: #666;
}

.part-history-similares li b { font-size: 15px; color: #1b1b1b; min-width: 48px; }

/* Acciones */
.part-history-acciones {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

.part-history-secundario,
.part-history-principal {
  border-radius: 8px;
  padding: 9px 16px;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
}

.part-history-secundario { background: #fff; border: 1px solid #ccc; color: #333; }
.part-history-secundario:hover { border-color: #111; }
.part-history-principal { background: #111; border: 1px solid #111; color: #fff; }
.part-history-principal:hover { background: #333; }

@media (max-width: 900px) {
  .part-history { padding: 20px 16px 40px; }
  .part-history-cuerpo { overflow-x: auto; }
}

/* LAKPED-21: dos bloques con su origen (ERP y parecidos), "Usar como base" en cada fila y las
   acciones arriba, como en la oferta. */
.part-history-cabecera-pagina {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px 20px;
  margin-bottom: 16px;
}
.part-history-cabecera-pagina .part-history-acciones { margin-top: 0; }
.part-history-bloque { margin-top: 16px; }

.part-history .part-history-base {
  border: 1px solid #111;
  background: #111;
  color: #fff;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 12.5px;
  white-space: nowrap;
}
.part-history .part-history-base:hover { background: #333; text-decoration: none; }

.part-history-parecidos {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 12px;
}
.part-history-parecido {
  display: flex;
  gap: 12px;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  padding: 10px;
  background: #fafafa;
}
.part-history-miniatura {
  width: 120px;
  height: 90px;
  object-fit: contain;
  background: #fff;
  border: 1px solid #ddd;
  flex: none;
}
.part-history-parecido-datos { display: flex; flex-direction: column; gap: 4px; min-width: 0; font-size: 13px; color: #666; }
.part-history-parecido-datos b { font-size: 16px; color: #1b1b1b; display: flex; align-items: center; gap: 8px; }
.part-history-parecido-nombre { color: #1b1b1b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.part-history-parecido-acciones { display: flex; gap: 8px; margin-top: 4px; }
.part-history-parecido-acciones button { padding: 6px 10px; font-size: 12.5px; white-space: nowrap; }

.part-history-spinner {
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 2px solid #999;
  border-top-color: transparent;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: -1px;
  animation: part-history-girar 0.8s linear infinite;
}
@keyframes part-history-girar { to { transform: rotate(360deg); } }

/* El paso Documento se pulsa para volver al documento (LAKPED-26). */
.part-history-pasos li.hecho { padding: 0; }
.part-history-pasos li.hecho button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 14px 5px 6px;
  border: none;
  background: none;
  font: inherit;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  border-radius: 20px;
}
.part-history-pasos li.hecho button:hover:not(:disabled) { background: #f2f2f2; text-decoration: underline; }
.part-history-pasos li.hecho button:disabled { cursor: default; color: #999; }
`, "",{"version":3,"sources":["webpack://./src/pages/PartHistoryPage.css"],"names":[],"mappings":"AAAA;4DAC4D;;AAE5D;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACpE,yBAAyB,WAAW,EAAE,eAAe,EAAE;AACvD;EACE,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,+BAA+B,WAAW,EAAE;AAC5C,gCAAgC,cAAc,EAAE;;AAEhD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,uDAAuD,gBAAgB,EAAE,WAAW,EAAE;AACtF,sDAAsD,mBAAmB,EAAE,cAAc,EAAE;;AAE3F,wBAAwB;AACxB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,gCAAgC,eAAe,EAAE,cAAc,EAAE;AACjE,sBAAsB,eAAe,EAAE,cAAc,EAAE;AACvD,sBAAsB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;;AAEhE;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE,uBAAuB,kBAAkB,EAAE,gCAAgC,EAAE;AAC7E,kCAAkC,mBAAmB,EAAE;AACvD,0BAA0B,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAE/F,wBAAwB;AACxB,sBAAsB,WAAW,EAAE,yBAAyB,EAAE,eAAe,EAAE;AAC/E;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;AACA,yBAAyB,gBAAgB,EAAE,gCAAgC,EAAE,WAAW,EAAE;AAC1F,yDAAyD,iBAAiB,EAAE;AAC5E,6CAA6C,mBAAmB,EAAE;;AAElE;;;;EAIE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;uCAGuC,0BAA0B,EAAE;;AAEnE,oBAAoB,iBAAiB,EAAE,WAAW,EAAE,eAAe,EAAE;AACrE,sBAAsB,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAEtE;;0BAE0B,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAEnE;;;EAGE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,WAAW;AACb;;AAEA,+BAA+B,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEjF,aAAa;AACb;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA,2BAA2B,gBAAgB,EAAE,sBAAsB,EAAE,WAAW,EAAE;AAClF,iCAAiC,kBAAkB,EAAE;AACrD,0BAA0B,gBAAgB,EAAE,sBAAsB,EAAE,WAAW,EAAE;AACjF,gCAAgC,gBAAgB,EAAE;;AAElD;EACE,gBAAgB,uBAAuB,EAAE;EACzC,uBAAuB,gBAAgB,EAAE;AAC3C;;AAEA;wCACwC;AACxC;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;AACA,uDAAuD,aAAa,EAAE;AACtE,uBAAuB,gBAAgB,EAAE;;AAEzC;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;AACA,yCAAyC,gBAAgB,EAAE,qBAAqB,EAAE;;AAElF;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;AACZ;AACA,+BAA+B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE,eAAe,EAAE,WAAW,EAAE;AAC5H,iCAAiC,eAAe,EAAE,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAChH,gCAAgC,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAChH,kCAAkC,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC5E,yCAAyC,iBAAiB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;;AAEpG;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,kDAAkD;AACpD;AACA,gCAAgC,KAAK,yBAAyB,EAAE,EAAE;;AAElE,qEAAqE;AACrE,+BAA+B,UAAU,EAAE;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA,2DAA2D,mBAAmB,EAAE,0BAA0B,EAAE;AAC5G,+CAA+C,eAAe,EAAE,WAAW,EAAE","sourcesContent":["/* LAKPED-16.2 — «qué sabemos ya» de la pieza. Mismos valores que el prototipo de Paula,\n   acotado a .part-history porque el CSS de CRA es global. */\n\n.part-history {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 28px 32px 60px;\n}\n\n.part-history h1 {\n  font-size: 26px;\n  font-weight: 600;\n  margin: 0 0 4px;\n  color: #1b1b1b;\n}\n\n.part-history-sub { color: #666; font-size: 14px; margin: 0 0 20px; }\n.part-history-cargando { color: #666; font-size: 14px; }\n.part-history-error {\n  color: #5a2a00;\n  background: #fff0e3;\n  border-left: 4px solid #e46a00;\n  border-radius: 0 6px 6px 0;\n  padding: 9px 12px;\n  font-size: 13px;\n}\n\n/* Pasos */\n.part-history-pasos {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  list-style: none;\n  margin: 0 0 20px;\n  padding: 0;\n}\n\n.part-history-pasos li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #888;\n  background: #fff;\n  border: 1px solid #e3e3e3;\n  border-radius: 20px;\n  padding: 5px 14px 5px 6px;\n}\n\n.part-history-pasos li.hecho { color: #333; }\n.part-history-pasos li.actual { color: #1b1b1b; }\n\n.part-history-paso-num {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #e5e5e5;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n}\n\n.part-history-pasos li.actual .part-history-paso-num { background: #111; color: #fff; }\n.part-history-pasos li.hecho .part-history-paso-num { background: #dff5e8; color: #157347; }\n\n/* Tarjeta de la pieza */\n.part-history-pieza {\n  background: #fff;\n  border: 1px solid #e3e3e3;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.part-history-cabecera {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 18px;\n  background: #fafafa;\n  border-bottom: 1px solid #eee;\n}\n\n.part-history-cabecera strong { font-size: 16px; color: #1b1b1b; }\n.part-history-aviso { font-size: 13px; color: #8a6100; }\n.part-history-chips { display: flex; flex-wrap: wrap; gap: 6px; }\n\n.part-history-chip {\n  display: inline-block;\n  background: #f0f0f0;\n  color: #333;\n  border-radius: 14px;\n  padding: 3px 10px;\n  font-size: 12px;\n}\n\n.part-history-chip.verde { background: #dff5e8; color: #157347; }\n.part-history-chip.ambar { background: #fff1cc; color: #8a6100; }\n\n.part-history-cuerpo { padding: 14px 18px; border-bottom: 1px solid #f2f2f2; }\n.part-history-cuerpo:last-child { border-bottom: none; }\n.part-history-cuerpo h3 { font-size: 14px; font-weight: 600; margin: 0 0 10px; color: #1b1b1b; }\n\n/* Tabla del histórico */\n.part-history-tabla { width: 100%; border-collapse: collapse; font-size: 13px; }\n.part-history-tabla th {\n  text-align: left;\n  font-weight: 600;\n  font-size: 12px;\n  color: #666;\n  padding: 6px 8px;\n  border-bottom: 1px solid #eee;\n}\n.part-history-tabla td { padding: 7px 8px; border-bottom: 1px solid #f4f4f4; color: #333; }\n.part-history-tabla th.der, .part-history-tabla td.der { text-align: right; }\n.part-history-tabla tbody tr:last-child td { border-bottom: none; }\n\n.part-history-tabla button,\n.part-history-ofertas button,\n.part-history-planos button,\n.part-history-similares button {\n  border: none;\n  background: none;\n  padding: 0;\n  color: #2563b0;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  text-align: left;\n}\n\n.part-history-tabla button:hover,\n.part-history-ofertas button:hover,\n.part-history-planos button:hover,\n.part-history-similares button:hover { text-decoration: underline; }\n\n.part-history-pie { font-size: 12.5px; color: #777; margin: 8px 0 0; }\n.part-history-vacio { font-size: 14px; color: #333; margin: 0 0 12px; }\n\n.part-history-ofertas,\n.part-history-planos,\n.part-history-similares { list-style: none; margin: 0; padding: 0; }\n\n.part-history-ofertas li,\n.part-history-planos li,\n.part-history-similares li {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 10px;\n  padding: 6px 0;\n  border-bottom: 1px solid #f4f4f4;\n  font-size: 13px;\n  color: #666;\n}\n\n.part-history-similares li b { font-size: 15px; color: #1b1b1b; min-width: 48px; }\n\n/* Acciones */\n.part-history-acciones {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 16px;\n}\n\n.part-history-secundario,\n.part-history-principal {\n  border-radius: 8px;\n  padding: 9px 16px;\n  font: inherit;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.part-history-secundario { background: #fff; border: 1px solid #ccc; color: #333; }\n.part-history-secundario:hover { border-color: #111; }\n.part-history-principal { background: #111; border: 1px solid #111; color: #fff; }\n.part-history-principal:hover { background: #333; }\n\n@media (max-width: 900px) {\n  .part-history { padding: 20px 16px 40px; }\n  .part-history-cuerpo { overflow-x: auto; }\n}\n\n/* LAKPED-21: dos bloques con su origen (ERP y parecidos), \"Usar como base\" en cada fila y las\n   acciones arriba, como en la oferta. */\n.part-history-cabecera-pagina {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px 20px;\n  margin-bottom: 16px;\n}\n.part-history-cabecera-pagina .part-history-acciones { margin-top: 0; }\n.part-history-bloque { margin-top: 16px; }\n\n.part-history .part-history-base {\n  border: 1px solid #111;\n  background: #111;\n  color: #fff;\n  border-radius: 6px;\n  padding: 5px 10px;\n  font-size: 12.5px;\n  white-space: nowrap;\n}\n.part-history .part-history-base:hover { background: #333; text-decoration: none; }\n\n.part-history-parecidos {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));\n  gap: 12px;\n}\n.part-history-parecido {\n  display: flex;\n  gap: 12px;\n  border: 1px solid #e3e3e3;\n  border-radius: 8px;\n  padding: 10px;\n  background: #fafafa;\n}\n.part-history-miniatura {\n  width: 120px;\n  height: 90px;\n  object-fit: contain;\n  background: #fff;\n  border: 1px solid #ddd;\n  flex: none;\n}\n.part-history-parecido-datos { display: flex; flex-direction: column; gap: 4px; min-width: 0; font-size: 13px; color: #666; }\n.part-history-parecido-datos b { font-size: 16px; color: #1b1b1b; display: flex; align-items: center; gap: 8px; }\n.part-history-parecido-nombre { color: #1b1b1b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.part-history-parecido-acciones { display: flex; gap: 8px; margin-top: 4px; }\n.part-history-parecido-acciones button { padding: 6px 10px; font-size: 12.5px; white-space: nowrap; }\n\n.part-history-spinner {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border: 2px solid #999;\n  border-top-color: transparent;\n  border-radius: 50%;\n  margin-right: 4px;\n  vertical-align: -1px;\n  animation: part-history-girar 0.8s linear infinite;\n}\n@keyframes part-history-girar { to { transform: rotate(360deg); } }\n\n/* El paso Documento se pulsa para volver al documento (LAKPED-26). */\n.part-history-pasos li.hecho { padding: 0; }\n.part-history-pasos li.hecho button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 14px 5px 6px;\n  border: none;\n  background: none;\n  font: inherit;\n  font-size: 13px;\n  color: #333;\n  cursor: pointer;\n  border-radius: 20px;\n}\n.part-history-pasos li.hecho button:hover:not(:disabled) { background: #f2f2f2; text-decoration: underline; }\n.part-history-pasos li.hecho button:disabled { cursor: default; color: #999; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
